module.exports = __webpack_public_path__ + "media/typing-advanced-end.eb7ac93d.mp3";